import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import Icon from 'Components/Icon';
import { occupancyShape } from 'Constants/PropTypes';

class Trigger extends Component {
    static getTotalOfChildrenMessage(childrenQuantity) {
        let totalOfChildren = '';
        if (childrenQuantity !== 0) {
            totalOfChildren = (
                <>
                    <FormattedMessage id="bf.and" defaultMessage="bf.and" />
                    &nbsp;
                    <FormattedMessage id="bf.childrenCount" defaultMessage="bf.childrenCount" values={{ count: childrenQuantity }} />
                </>
            );
        }

        return totalOfChildren;
    }

    constructor() {
        super();
        this.getChildrenQuantity = this.getChildrenQuantity.bind(this);
    }

    getChildrenQuantity() {
        const { occupancy } = this.props;
        return occupancy.reduce((total, room) => total + room.children?.length, 0);
    }

    render() {
        const { occupancy, triggerRef, isOccupancyActive, allowRooms } = this.props;

        const roomsQuantity = occupancy.length;
        const totalOfRooms = <FormattedMessage id="bf.roomsCount" defaultMessage="bf.roomsCount" values={{ count: roomsQuantity }} />;
        const adultsQuantity = occupancy.reduce((total, room) => total + room.adults, 0);
        const totalOfAdults = <FormattedMessage id="bf.adultsCount" defaultMessage="bf.adultsCount" values={{ count: adultsQuantity }} />;
        const childrenQuantity = this.getChildrenQuantity(occupancy);
        const totalOfChildren = Trigger.getTotalOfChildrenMessage(childrenQuantity);

        return (
            <div
                ref={triggerRef}
                className={`kbe-flex kbe-flex-middle kbe-dropdown-click ${isOccupancyActive ? 'kbe-active' : ''}
                    search-bar-input-custom-class`}
            >
                <span className="kbe-dropdown-details">
                    {allowRooms ? <FormattedMessage
                        id="bf.searchSummary"
                        defaultMessage="bf.searchSummary"
                        values={{ totalOfRooms, totalOfAdults, totalOfChildren }}
                    /> : <div>{totalOfAdults} {totalOfChildren}</div> }
                </span>
                <Icon name="CaretDown" fill="rgba(255, 255, 255, .9)" size="10" />
            </div>
        );
    }
}

Trigger.defaultProps = {
    allowRooms        : true,
};

Trigger.propTypes = {
    occupancy         : PropTypes.arrayOf(PropTypes.shape(occupancyShape)).isRequired,
    triggerRef        : PropTypes.oneOfType([ PropTypes.func, PropTypes.object ]).isRequired,
    isOccupancyActive : PropTypes.bool.isRequired,
    allowRooms        : PropTypes.bool,
};

export default Trigger;
